import React from 'react';
import Banner from '../Components/Pages/Wireframe/Banner';
import Features from '../Components/Pages/Wireframe/Features';
import Header from '../Components/Shared/Header/Header';
import Join from '../Components/Pages/Collaboration/Join';
import Concept from '../Components/Pages/Wireframe/Concept';
import Testimonial from '../Components/Pages/Wireframe/Testimonial';
import InnovativePart from '../Components/Pages/Home/Innovative';
import Device from '../Components/Pages/Wireframe/Device';
import Design from '../Components/Pages/Home/Design';
import Bg from '../Assets/Cards/designDashboard.webp';
import Blogs from '../Components/Shared/BlogsSection/Blogs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';

function Wireframe(){
    return(
        <>
        <Header />
        <Banner />
        <Features />
        <Join />
        <Concept />
        <Testimonial />
        <InnovativePart />
        <Device />
        <Design 
        title="Access from anywhere"
        desc="Share with your colleagues, clients and stakeholders at the click of a button. Simple link sharing means you can access your wireframe anywhere and open on any device.

        Once they have access, HostDesign becomes the wireframe tool and collaboration platform for you and your team to give actionable feedback."
        backgroundImage={Bg}
        />
        <Start />
        <Footer />
        </>
    )
};
export default Wireframe ;